var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "500px" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c("span", { staticClass: "headline" }, [
                _vm._v("Item Social (" + _vm._s(this.rules.name) + ")"),
              ]),
              _c("v-spacer"),
              _c("v-switch", {
                staticClass: "mb-5",
                attrs: {
                  label: "Enabled",
                  color: "success",
                  "hide-details": "",
                },
                model: {
                  value: _vm.model.enabled,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "enabled", $$v)
                  },
                  expression: "model.enabled",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "12", sm: "12" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-2",
                          attrs: { small: "" },
                          on: {
                            click: function ($event) {
                              return _vm.showPreview()
                            },
                          },
                        },
                        [_vm._v("View JSON")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mb-4", attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "9", md: "9" } },
                    [
                      _c("r-item-dropdown", {
                        attrs: { model: _vm.model.key },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "key", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "3", md: "3" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Rarity:", "hide-details": "" },
                        model: {
                          value: _vm.model.rarity,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "rarity", _vm._n($$v))
                          },
                          expression: "model.rarity",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-col", { attrs: { cols: "12", sm: "12", md: "12" } }),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-expansion-panels",
                    [
                      _c("r-guard-panel", {
                        attrs: { model: _vm.model.guard },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "guard", $event)
                          },
                        },
                      }),
                      _c("r-reward-panel", {
                        attrs: {
                          model: _vm.model.playerReward,
                          title: "Player Reward",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "playerReward", $event)
                          },
                        },
                      }),
                      _c("r-reward-panel", {
                        attrs: {
                          model: _vm.model.friendReward,
                          title: "Friend Reward",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "friendReward", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
          _c("r-preview-dialog", { ref: "preview-dialog" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }